
          import { defineNuxtPlugin } from "#imports";

          export default defineNuxtPlugin({
            name: 'sentry-client-config',
            async setup() {
              await import("C:/Users/Charl/Downloads/ipa-lms-live/sentry.client.config.ts")
            }
          });